<atn-ds-page>
  <atn-ds-page-header
    pageHeader
    [name]="zoneNameSg()"
    [breadcrumbs]="breadcrumbsSg()"
  />
  <atn-ds-floating-horizontal-tabs>
    <ng-template
      atnDsTab
      name="General"
    >
      <atn-admin-zone-page-general-tab />
    </ng-template>

    <ng-template
      atnDsTab
      name="Applications"
    >
      <atn-admin-zone-page-apps-tab />
    </ng-template>

    @if (canManageUsersSg()) {
      <ng-template
        atnDsTab
        name="Users"
      >
        <atn-admin-zone-page-users-tab />
      </ng-template>
    }

    @if (canManageUsersSg()) {
      <ng-template
        atnDsTab
        name="Agents"
      >
        <atn-admin-zone-page-agents-tab />
      </ng-template>
    }

    <ng-template
      atnDsTab
      name="Integrations"
    >
      <atn-admin-zone-page-integrations-tab />
    </ng-template>
  </atn-ds-floating-horizontal-tabs>
</atn-ds-page>
